export default "__VITE_ASSET__Dy66vFwI__"